import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorAchUpdateEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.ach.update),
			switchMap((action) =>
				this.vendorAdminService
					.updateBankAccountName(action.accountId, action.accountName, action.isActive)
					.pipe(
						map(() => VendorAdminActions.ach.updateSuccess()),
						catchError((error) =>
							of(VendorAdminActions.ach.updateFail(new FailState(error)))
						)
					)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
